// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._19itidpf{border:0}\n._2rko1l7b{border-radius:3px}._154iidpf{top:0}\n._18m915vq{overflow-y:hidden}\n._1bsb1osq{width:100%}\n._1ltvidpf{left:0}\n._1reo15vq{overflow-x:hidden}\n._4t3i1osq{height:100%}\n._kqswh2mm{position:relative}", ""]);
// Exports
module.exports = exports;
